export function dateBR(datetime: string) {
  const [date, time] = datetime.split(' ');
  return date.split('-').reverse().join('/');
}
